import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { FormsModule } from "@angular/forms";
/**********************************************************/

import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { AmountSpinnerComponent } from "shared/base-components/amount-spinner.component";
import { BfxBadgeComponent } from "shared/base-components/bfx-badge";
import { BfxIconButtonComponent } from "shared/base-components/bfx-icon-button";
import { BfxPipeModule } from "../../app/bfx-shared/bfx-pipes.module";
import { BfxFieldNumberDirective } from "./bfx-field-number";
import { BfxFieldSelectDirective } from "./bfx-field-select";
import { BfxFieldTextDirective } from "./bfx-field-text";
import { BfxInputDirective } from "./bfx-input";
import { BfxTextInputComponent } from "./bfx-text-input";
import { NumberSpinnerComponent } from "./number-spinner.component";
import { RateSpinnerComponent } from "./rate-spinner.component";
import { SpinnerButtonsComponent } from "./spinner-buttons.component";
import { BfxSplitterComponent } from "shared/base-components/bfx-splitter.component";
import { BfxSegmentedControlComponent } from "shared/base-components/bfx-segmented-control.component";
import { SplitButtonModule } from "@bfx/primeng/splitbutton";
import { BfxDropdownButtonComponent } from "shared/base-components/bfx-dropdown-button";

/**
 * Provides module-independent Component implementations. These encapulate all common model
 * and controller functionality of a component and app modules can enhance by subclassing and adding
 * addtional view parts
 */
@NgModule({
  declarations: [
    AmountSpinnerComponent,
    BfxFieldNumberDirective,
    BfxFieldTextDirective,
    BfxIconButtonComponent,
    BfxFieldSelectDirective,
    BfxInputDirective,
    BfxTextInputComponent,
    NumberSpinnerComponent,
    RateSpinnerComponent,
    SpinnerButtonsComponent,
    BfxBadgeComponent,
    BfxSplitterComponent,
    BfxSegmentedControlComponent,
    BfxDropdownButtonComponent,
  ],
  exports: [
    AmountSpinnerComponent,
    BfxFieldNumberDirective,
    BfxIconButtonComponent,
    BfxFieldTextDirective,
    BfxFieldSelectDirective,
    BfxInputDirective,
    BfxTextInputComponent,
    NumberSpinnerComponent,
    RateSpinnerComponent,
    SpinnerButtonsComponent,
    BfxBadgeComponent,
    BfxSplitterComponent,
    BfxSegmentedControlComponent,
    BfxDropdownButtonComponent,
  ],
  imports: [CommonModule, FormsModule, FlexLayoutModule, BfxPipeModule, SplitButtonModule],
  providers: [
    BfxFieldNumberDirective,
    BfxFieldTextDirective,
    BfxFieldSelectDirective,
    BfxInputDirective,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class BaseComponentsModule {}
